import { Popover, Pressed, Typography } from 'libs/ui';
import { CSSObject, styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

export const SelectStyled = styled(Pressed)(() => ({
  padding: '0 8px 0 12px',
  height: 32,
  border: `1px solid ${Colors.gray300}`,
  backgroundColor: Colors.white,
  borderRadius: 4,
  alignItems: 'center',
  gap: 4,

  '&:hover': {
    backgroundColor: Colors.gray100,
  },

  '.selectFilter-count': {
    backgroundColor: Colors.blue200,
    borderRadius: 2,
    padding: '0 8px',
    height: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '.selectFilter-count-label': {
      fontSize: 11,
      lineHeight: 1,
      color: Colors.blue600,
    } as CSSObject,
  } as CSSObject,
}));

export const PopoverStyled = styled(Popover)(() => ({
  [Popover.classes.paper]: {
    maxWidth: 320,
  },
}));

export const PopoverContentStyled = styled('div')(({ theme }) => ({
  overflowY: 'auto',

  '.selectFilter-search': {
    padding: '12px 16px',
  } as CSSObject,

  '.selectFilter-option': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: '8px 12px',
    gap: 8,

    transition: theme.transitions.create(['background']),

    '&:hover': {
      background: Colors.gray100,
    } as CSSObject,
  } as CSSObject,

  '.selectFilter-footer': {
    borderTop: `1px solid ${Colors.gray200}`,

    '.selectFilter-footer-collapse, .selectFilter-footer-clear': {
      width: '100%',
      padding: '8px 12px',
      ...theme.typography.captionMedium,

      '&:hover': {
        backgroundColor: Colors.gray100,
      } as CSSObject,
    },

    '.selectFilter-footer-collapse': {
      color: Colors.blue500,
    },

    '.selectFilter-footer-clear': {
      borderTop: `1px solid ${Colors.gray200}`,
      color: Colors.red500,
    },
  } as CSSObject,
}));

export const SelectFilterLoading = styled(Typography)(() => ({
  display: 'block',
  padding: '8px 12px',
  color: Colors.gray500,
}));
